import React, {useState} from "react";
import { isNativeApp } from "../../../../utils/index";
import {
  initialTableData,
  convertTableDataToSubscriptions,
  getOptIns,
  hasAnyPreferences
} from "./data"
import {updateNewEmailPreferences} from "../../../../api/custAccountApi";
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";
import {
  Button,
  Checkbox,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  SelectionControlLabel, Typography
} from "@one-thd/sui-atomic-components";

function InfoText(anyPreferences) {
  if(anyPreferences) {
    return (
      <Typography>
          Shown below are preferences tied to either your old or new email address.
          Please confirm your preference choices you want transferred and saved to your new email address.
      </Typography>
    )
  }
  if(isNativeApp()) {
    return (
      <Typography>
        You can stay informed about Home Depot’s products, promotions and offers by signing up for email communications.
      </Typography>
    )
  }
  return (
    <Typography>
      You can stay informed about Home Depot’s products, promotions and offers by signing up for email communications.
      To view, update, and manage your email preferences click on the <a className="u__default-link" href="/account/view/emailsubscription">My Preference Center</a> link in your account.
    </Typography>
  )
}

const EpcModal = ({emailEditContext, isOpen, onCloseEmailPreferenceTransferModal}) => {

  const { executeRecaptcha } = useGoogleReCaptcha();

  const {oldEmailPreferences, newEmailPreferences, oldEmail} = emailEditContext;

  const [selectedItems, setSelectedItems] = useState(getOptIns(oldEmailPreferences));
  const [tableData, setTableData] = useState(initialTableData(oldEmailPreferences, newEmailPreferences));
  const anyPreferences = hasAnyPreferences(oldEmailPreferences, newEmailPreferences);

  const handleChange = (event) => {
    const { id, checked } = event.target;
    const item = parseInt(id.slice(-1), 10);
    const table = tableData;

    table[item].checked = checked;
    setSelectedItems((items) => {
      return items.includes(item)
        ? items.filter((i) => i !== item)
        : [...items, item];
    })
    setTableData([...table])
  }

  const handleSave = () => {
    const updatedNewPreferences = convertTableDataToSubscriptions(selectedItems, tableData)
    if(updatedNewPreferences.length) {
      const newEmail = emailEditContext?.newEmail || emailEditContext?.email;
      updateNewEmailPreferences(newEmail, updatedNewPreferences, executeRecaptcha).then(() => {});
    }
    onCloseEmailPreferenceTransferModal();
  }

  return (
    <Modal
      open={isOpen}
      onClose={onCloseEmailPreferenceTransferModal}
    >
      <ModalHeader>
        {oldEmail
            ? "Would you like to transfer your email preferences?"
            : "Want to stay connected"
        }
      </ModalHeader>
      <ModalBody>
        <div className='sui-grid sui-gap-2'>
          <InfoText anyPreferences={anyPreferences} />
          {tableData.map((row, index) => (
            <SelectionControlLabel key={`table-row-${row.key}`}>
              <div className='sui-grid sui-grid-cols-12 sui-w-full'>
                <div className='sui-m-auto sui-col-span-2'>
                  <Checkbox id={`email-${index}`} checked={row.checked} value={row.key} onChange={handleChange} />
                </div>
                <div className='sui-grid sui-col-span-10'>
                  <Typography variant='h5'>
                    {row.title}
                  </Typography>
                  <Typography>
                    {row.subText}
                  </Typography>
                </div>
              </div>
            </SelectionControlLabel>
          ))}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button fullWidth onClick={handleSave}>
          Save
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default EpcModal;
